import { gql } from 'graphql-tag'

export default gql`
  fragment GlobalDataProductFragment on GlobalDataProduct {
    sys {
      id
    }
    contentType: __typename
    internalName
    name
    icon
  }
`
